<template>
  <v-container
    id="contact"
    class="pa-0 grey lighten-3 flex-wrap align-start fill-height"
    fluid
    tag="section"
  >
    <iframe
      allowfullscreen
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d81056.62457435575!2d36.50309514047092!3d50.589590537022524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41266af42d5c5863%3A0xc4cfd2138d424649!2z0JHQtdC70LPQvtGA0L7QtCwg0JHQtdC70LPQvtGA0L7QtNGB0LrQsNGPINC-0LHQuy4!5e0!3m2!1sru!2sru!4v1598457742910!5m2!1sru!2sru"
      style="border:0"
      width="100%"
    />

    <v-row
      class="ma-0"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
        class="mt-16"
      >
        <h1 class="display-1 lushary--text mb-8 font-weight-bold">
          Мои контакты:
        </h1>

        <div class="grey--text mb-8">
          Вы можете связаться со мной с помощью социальных сетей, еmail или позвонив по номеру телефона.
        </div>

        <div class="mb-4">
          <strong
            class="lushary--text"
          >Телефон:</strong> <a href="tel:+79511387504">+7 (951) 138-75-04</a>
        </div>

        <div class="mb-4">
          <strong
            class="lushary--text"
          >Email:</strong> <a href="mailto:shackalowa.dasha@yandex.ru">shackalowa.dasha@yandex.ru</a>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <v-img
          src="../../assets/logo.svg"
          contain
          class="ma-4 d-none d-md-block shrink mx-6"
          height="calc(3em * 5)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { functions } from '@/plugins/firebase'
  export default {
    name: 'Contact',
    data: () => ({
      valid: false,
      loading: false,
      name: '',
      title: '',
      text: '',
      emailFrom: '',
      emailTo: 'cslamer@mail.ru',
      emailRules: [
        v => !!v || 'Поле является обязательным для заполнения',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Поле email введено не корректно!',
      ],
      nameRules: [
        v => !!v || 'Поле является обязательным для заполнения',
        v => (v && v.length >= 2) || 'Более двух символов',
      ],
      titleRules: [
        v => !!v || 'Поле является обязательным для заполнения',
        v => (v && v.length >= 3 && v.length <= 30) || 'Минимум 3 Максимум 30 символов',
      ],
      textRules: [
        v => !!v || 'Поле является обязательным для заполнения',
        v => (v && v.length >= 10) || 'Минимум 10 символов',
      ],
    }),
    methods: {
      sentMessage () {
        if (this.$refs.form.validate()) {
          try {
            this.loading = true
            // construct an email
            const callable = functions.httpsCallable('genericEmail')
            return callable({ text: this.text, subject: this.title, name: this.name, emailTo: this.emailTo, emailFrom: this.emailFrom })
              .then(this.resetForm)
          } catch (e) {
            this.loading = false
          }
        }
      },
      resetForm () {
        this.title = ''
        this.emailFrom = ''
        this.name = ''
        this.text = ''
        this.loading = false
      },
    },
  }
</script>
